import createLucideIcon from '../createLucideIcon';

const BarChart2 = createLucideIcon('BarChart2Icon', [
  ['line', { x1: '18', y1: '20', x2: '18', y2: '10', key: '1e8c49' }],
  ['line', { x1: '12', y1: '20', x2: '12', y2: '4', key: '65j799' }],
  ['line', { x1: '6', y1: '20', x2: '6', y2: '14', key: '4svqks' }],
]);

export default BarChart2;
